import { createContext, useContext, useEffect, useReducer } from "react";
import { supabase } from '../supabaseClient'; // Import Supabase client

const StrategicSuggestions = createContext();

const initialSuggestions = {
  byId: {},
  byAttrId: {},
  categories: {},
};

const strategicSuggestionReducer = (state, action) => {
  switch (action.type) {
    case "SET_SUGGESTIONS":
      const suggestionsWithLinksMap = action.suggestions.map(suggestion => ({
        ...suggestion,
        linksMap: suggestion.links
          ? suggestion.links.reduce((acc, link) => {
              if (!acc[link.audience]) acc[link.audience] = [];
              acc[link.audience].push(link);
              return acc;
            }, {})
          : {}
      }));   
      return {
        byId: suggestionsWithLinksMap.reduce((acc, suggestion) => {
          acc[suggestion.suggestion_id] = suggestion;
          return acc;
        }, {}),
        byAttrId: suggestionsWithLinksMap.reduce((acc, suggestion) => {
          acc[suggestion.attribute_id] = suggestion;
          return acc;
        }, {}),
        categories: suggestionsWithLinksMap.reduce((acc, ss) => {
          acc[ss.suggestion_id] = ss.title;
          return acc;
        }, {})
      };
    default:
      return state;
  }
};

export function StrategicSuggestionsProvider({ children, initial }) {
  const [strategicSuggestions, dispatch] = 
    useReducer(strategicSuggestionReducer, initial || initialSuggestions);

  // Load suggestions on mount
  useEffect(() => {
    let isMounted = true;
    let timeoutId = null;
    const delay = 1000; // ms

    const fetchSuggestions = async (attempt = 1) => {
      const { data, error } = await supabase.rpc('get_strategic_suggestions');
      if (error || !data ) {
        if (isMounted) {
          timeoutId = setTimeout(() => fetchSuggestions(attempt + 1), delay);
        } else if (error) {
          console.error('Error fetching suggestions:', error);
        }
        return;
      }
      if (isMounted && data && data.suggestions) {
        dispatch({ type: "SET_SUGGESTIONS", suggestions: data.suggestions });
      }
    };

    fetchSuggestions();

  return () => {
    isMounted = false;
    if (timeoutId) clearTimeout(timeoutId);
  };
  }, []);

  return (
    <StrategicSuggestions.Provider value={{ strategicSuggestions, dispatch }}>
      {children}
    </StrategicSuggestions.Provider>
  );
}

export const useStrategicSuggestions = () => {
  return useContext(StrategicSuggestions);
};
